<template>
    <div id="home">
        <div id="home-head">
            <carousel :autoplay="true" :per-page="1" :autoplay-timeout="3000" :loop="true" :autoplay-hover-pause="false">
                <slide v-for="(image, i) in loadImages" :key="i">
                    <img :src="image.src" :alt="'Home Image ' + image.image_name">
                </slide>
            </carousel>
            <p :class="home.color === 'white' ? 'page-title title-white' : 'page-title title-black'">The Mark
                of<br/> Excellence</p>
            <!--<v-carousel dark hide-controls interval="4000">-->
                <!--<v-carousel-item v-for="(image,i) in loadImages" :key="i" :src="`${home.imagePath}/${image.image_name}`">-->
                <!--</v-carousel-item>-->
                <!--<p :class="home.color === 'white' ? 'page-title title-white' : 'page-title title-black'">The Mark-->
                    <!--of<br/> Excellence</p>-->
            <!--</v-carousel>-->

            <router-link class="start" :to="{ name: 'Contact' }">Start Today</router-link>
        </div>

        <div id="home-chips">
            <div class="ech-chip">
                <router-link tag="img" :to="{ name: 'Communities' }" alt=""
                             src="https://elitecrafthomes.com/static_files/images/Home_Communities.jpeg"></router-link>
                <div class="ech-chip-cutout">
                    <router-link tag="p" :to="{ name: 'Communities' }">Communities</router-link>
                </div>
            </div>

            <div class="ech-chip">
                <router-link tag="img" :to="{ name: 'Plans' }" alt=""
                             src="https://elitecrafthomes.com/static_files/images/Home_FloorPlans.jpeg"></router-link>
                <div class="ech-chip-cutout">
                    <router-link tag="p" :to="{ name: 'Plans' }">Plans</router-link>
                </div>
            </div>

            <div class="ech-chip">
                <router-link tag="img" :to="{ name: 'Contact' }" alt=""
                             src="https://elitecrafthomes.com/static_files/images/Home_Contact.jpg"></router-link>
                <div class="ech-chip-cutout">
                    <router-link tag="p" :to="{ name: 'Contact' }">Contact Us</router-link>
                </div>
            </div>
        </div>

        <div id="communities">
            <p class="ech-title">Popular Communities</p>
            <div class="community" v-for="(community, i) in home.communities" :key="i"
                 v-if="community.display === true">
                <router-link tag="img" :to="{ path: '/communities/' + community.community_name}"
                             :src="community.thumbnail_src"></router-link>

                <div>
                    <p>{{ community.title }}</p>
                    <p>City: {{ community.location.city }}</p>
                    <p>Acres: {{ community.acres }}</p>
                    <p>Available Lots: {{ community.available_lots }}</p>
                </div>
            </div>

        </div>

        <div id="testimonials">
            <p class="ech-title">Testimonials</p>
            <v-container fluid>
                <v-layout v-for="(item, i) in loadTestimonials" :key="i" v-if="i < 3" class="testimonial"
                          column align-center justify-center>
                    <v-flex md4 xs12 s12 lg4 xl4>
                        <v-icon class="testimonial_quote" color="black" large>fas fa-quote-left</v-icon>
                        <p>{{ item.message }}<b>...</b></p>
                        <p>- {{ item.full_name }}</p>
                    </v-flex>
                </v-layout>
            </v-container>
            <div>
                <router-link tag="button" :to="{ name: 'Testimonials' }" class="read_more">Read More Testimonials</router-link>
            </div>
        </div>

        <router-link tag="div" :to="{ name: 'WhoWeAre' }" id="footer-top">
            <div>
                <img src="../../static/images/Home_AboutUs_Image.jpg" alt="">
            </div>
            <div>
                <div>
                    <p>At Elite Craft Homes, we have a
                        unique approach to building homes.
                        Unlike the majority of our
                        competitors, you are not limied to
                        our plans or our communities - we
                        build what you want, where you
                        want.</p>
                    <router-link :to="{ name: 'WhoWeAre' }">About Us</router-link>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    const apiToken = require('../../credentials').API_TOKEN;
    const urlPath = require('../../credentials').URL_PATH;
    import axios from 'axios'
    // TODO - when we read in the Testimonials, cut off at 240 characters and add a ...
    const data = {
        home: {
            images: [],
            testimonials: [],
            communities: [],
            imagePath: 'https://elitecrafthomes.com/static_files/images',
            color: '',
            communityLocation: [] // This should be a dict with the community name matching the location object which is an array
        }
    };

    export default {
        name: 'Home',
        data() {
            return data
        },
        computed: {
            loadImages() {
                if (this.home !== undefined && this.home !== 'undefined') {
                    return this.home.images;
                }
            },
            loadTestimonials() {
                if (this.home !== undefined && this.home !== 'undefined') {
                    return this.home.testimonials;
                }
            }
        },
        methods: {
            hydrateTestimonials() {
                axios.get(urlPath + 'testimonials/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.home.testimonials = res.data;
                        setTimeout(() => {
                            this.parseTestimonials()
                        }, 100)
                    }, (res) => {
                        // TODO - have an api call that sends all errors to a db to look at for the future
                    })
            },

            parseTestimonials() {
                this.home.testimonials.forEach((element, i) => {
                    if (this.home !== undefined && this.home !== 'undefined') {
                        let message = element.message.split(' ');
                        this.home.testimonials[i].message = message[0];
                        for (let j = 1; j < message.length; j++) {
                            if (j < 60) {
                                this.home.testimonials[i].message += ' ' + message[j]
                            }
                        }

                    }

                        // this.home.testimonials[i].message = element.message.slice(0, 325);
                });
            },

            loadCommunities() {
                axios.get(urlPath + 'communities/communities/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.home.communities = res.data;
                    })
            },
            hydrateImages() {
                this.home.images = [];
                axios.get(urlPath + 'homepageimages/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then(res => {
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].disabled === false) {
                                this.home.images.push(res.data[i])
                            }
                        }
                    })
            }
        },
        created() {
            this.hydrateTestimonials();
            this.loadCommunities();
            this.hydrateImages();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @font-face {
        font-family: "Tahu";
        src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
        url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
    }

    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    button.read_more {
        font-size: 20px;
        border: 3px solid white;
        background-color: #425152;
        color: white;
        width: 270px;
        padding: 7px 0;
        text-decoration: none;
        text-align: center;
        -webkit-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
        -moz-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
        box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
        outline: none;
        font-weight: 600;
        cursor: pointer;
        z-index: 9;
    }

    @media screen and (max-width: 450px) {
        button.read_more {
            font-size: 18px;
            border: 3px solid white;
            background-color: #425152;
            color: white;
            width: 240px;
            padding: 7px 0;
            text-decoration: none;
            text-align: center;
            -webkit-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
            -moz-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
            box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
            outline: none;
            font-weight: 600;
            cursor: pointer;
            z-index: 9;
        }
        p.ech-title {
            font-family: "LibreBaskerville Bold", sans-serif;
            font-size: 24px;
            text-align: center;
            padding-bottom: 50px;
        }
        #home {
            background-color: white;
            text-align: center;
            #home-head {
                position: relative;
                height: 430px;
                /*div.carousel {*/
                    /*max-height: 430px;*/
                    /*height: 430px;*/
                img {
                    height: 400px;
                    max-height: 400px;
                    width: 100vw;
                    max-width: 100vw;
                }
                    /*<!--div.carousel__left {-->*/
                        /*<!--position: absolute;-->*/
                        /*<!--top: 70%;-->*/
                        /*<!-- -webkit-transform: translateY(-30%);-->*/
                        /*<!-- -moz-transform: translateY(-30%);-->*/
                        /*<!-- -ms-transform: translateY(-30%);-->*/
                        /*<!-- -o-transform: translateY(-30%);-->*/
                        /*<!--transform: translateY(-30%);-->*/
                    /*<!--}-->*/
                /*}*/

                .page-title {
                    font-family: "Tahu", "Muli", "Avenir", "Helvetica Neue", serif;
                    font-size: 40px;
                    position: absolute;
                    top: 25%;
                    left: 50%;
                    -webkit-transform: translateX(-50%);
                    -moz-transform: translateX(-50%);
                    -ms-transform: translateX(-50%);
                    -o-transform: translateX(-50%);
                    transform: translateX(-50%);
                    color: white;
                    width: 100%;
                    br {
                        display: none;
                    }
                }
                .start {
                    width: 165px;
                    font-size: 20px;
                    background-color: #425152;
                    color: white;
                    padding: 7px 0;
                    border: 2px solid white;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -moz-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    -o-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    outline: none;
                    font-weight: 600;
                    cursor: pointer;
                    z-index: 9;
                    text-decoration: none;
                    text-align: center;
                }

            }

            #home-chips {
                /*position: relative;*/
                max-width: 220px;
                width: 100%;
                margin: 25px auto 0 auto;
                img {
                    margin-top: 25px;
                    max-width: 230px;
                    max-height: 220px;
                    width: 230px;
                    height: 220px;
                    object-fit: fill;
                }
                p {
                    padding-top: 10px;
                    font-size: 20px;
                }
            }

            #communities {
                margin-top: 50px;
                padding: 0 10px;
                p.ech-title {
                    font-family: "LibreBaskerville Bold", sans-serif;
                    font-size: 24px;
                    text-align: center;
                    padding-bottom: 50px;
                }
                .community {
                    position: relative;
                    height: 155px;
                    div {
                        position: absolute;
                        width: 50vw;
                        top: 50%;
                        -webkit-transform: translateY(-50%);
                        -moz-transform: translateY(-50%);
                        -ms-transform: translateY(-50%);
                        -o-transform: translateY(-50%);
                        transform: translateY(-50%);

                        p:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 1;
                        }
                        p:not(:nth-of-type(1)) {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                        }
                    }
                    img {
                        max-width: 167px;
                        width: 167px;
                        max-height: 152px;
                        height: 152px;
                        object-fit: fill;
                    }
                }
                .community:nth-of-type(1) {
                    img {
                        float: left;
                    }

                    div {
                        padding-left: 20px;
                        right: 0;
                        text-align: left;
                    }
                }
                .community:nth-of-type(2) {
                    img {
                        position: absolute;
                        right: 0;
                    }
                    div {
                        text-align: right;
                        padding-right: 20px;
                        left: 0;
                    }
                }

                .community:nth-of-type(3) {
                    img {
                        float: left;
                    }
                    div {
                        padding-left: 20px;
                        right: 0;
                        text-align: left;
                    }
                }

                .community:nth-of-type(4) {
                    img {
                        position: absolute;
                        right: 0;
                    }
                    div {
                        text-align: right;
                        padding-right: 20px;
                        left: 0;
                    }
                }
            }

            #testimonials {
                margin: 65px 0 240px 0;
                padding: 0 20px;
                .testimonial {
                    margin: 10px 0;
                    .testimonial_quote {
                        margin-bottom: 25px;
                    }
                    p:nth-of-type(2) {
                        font-weight: bolder;
                    }
                }
            }

            #footer-top {
                position: relative;
                height: 428px;
                margin-top: -175px;
                /*margin-bottom: 50px;*/
                div {
                    background-color: rgba(0, 0, 0, 0.65);
                    overflow: hidden;
                    img {
                        max-height: 428px;
                        height: 428px;
                        max-width: 100vw;
                        width: 100vw;
                        object-fit: fill;
                        opacity: .4;
                        -webkit-transform: scaleX(1.3);
                        -moz-transform: scaleX(1.3);
                        -ms-transform: scaleX(1.3);
                        -o-transform: scaleX(1.3);
                        transform: scaleX(1.3);
                    }
                }

                p {
                    position: absolute;
                    top: 50%;
                    -webkit-transform: translateY(-50%);
                    -moz-transform: translateY(-50%);
                    -ms-transform: translateY(-50%);
                    -o-transform: translateY(-50%);
                    transform: translateY(-50%);
                    padding-left: 15px;
                    padding-right: 30px;
                    color: #eee;
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 1.2;
                    z-index: 99;
                    text-align: left;
                }
                a {
                    font-size: 20px;
                    border: 3px solid white;
                    background-color: #425152;
                    color: white;
                    width: 165px;
                    position: absolute;
                    padding: 7px 0;
                    bottom: 15%;
                    left: 15px;
                    -webkit-transform: translateY(-15%);
                    -moz-transform: translateY(-15%);
                    -ms-transform: translateY(-15%);
                    -o-transform: translateY(-15%);
                    transform: translateY(-15%);
                    float: left;
                    text-decoration: none;
                    text-align: center;
                }

            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 768px) {
        p.ech-title {
            font-family: "LibreBaskerville Bold", sans-serif;
            font-size: 32px;
            text-align: center;
            padding-bottom: 50px;
        }
        #home {
            max-width: 768px;
            width: 100%;
            background-color: white;
            text-align: center;
            img {
                max-width: 100vw;
            }
            #home-head {
                position: relative;
                height: 500px;
                width: 100%;
                /*div.carousel {*/
                    /*max-height: 500px;*/
                    /*height: 500px;*/
                    /*color: white;*/
                    /*width: 100vw;*/
                    /*min-width: 100vw;*/
                img {
                    height: 425px;
                    max-height: 425px;
                    width: 100vw;
                    min-width: 100vw;
                    max-width: 100vw;
                }
                /*}*/

                .page-title {
                    font-family: "Tahu", "Muli", "Avenir", "Helvetica Neue", serif;
                    font-size: 4.5em;
                    position: absolute;
                    text-align: left;
                    line-height: 1.1;
                    top: 22%;
                    left: 15%;
                    color: white;
                }
                .start {
                    width: 165px;
                    font-size: 24px;
                    background-color: #425152;
                    color: white;
                    padding: 7px 0;
                    border: 2px solid white;
                    position: absolute;
                    top: 60%;
                    left: 15%;
                    outline: none;
                    font-weight: 500;
                    cursor: pointer;
                    z-index: 9;
                    text-decoration: none;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }

            #home-chips {
                clear: both;
                position: relative;
                height: 225px;
                max-height: 225px;
                margin: 50px auto 0 auto;
                max-width: 768px;
                width: 100%;
                text-align: center;
                display: inline-block;
                div.ech-chip:nth-of-type(1) {
                    margin: 0 5px 0 0;
                }
                div.ech-chip:nth-of-type(2) {
                    margin: 0 5px;
                }
                div.ech-chip:nth-of-type(3) {
                    margin: 0 0 0 5px;
                }
                div.ech-chip {
                    width: 31%;
                    max-width: 31%;
                    display: inline-block;
                    height: 225px;
                    max-height: 225px;
                    position: relative;
                    cursor: pointer;
                    img {
                        max-width: 100%;
                        width: 100%;
                        max-height: 225px;
                        height: 225px;
                        object-fit: fill;
                    }
                    div.ech-chip-cutout {
                        background-color: white;
                        max-width: 150px;
                        width: 100%;
                        height: 80px;
                        max-height: 80px;
                        position: absolute;
                        bottom: 0;
                        p {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            font-size: 16px;
                            text-align: left;
                            -webkit-transform: translate(-50%, -50%);
                            -moz-transform: translate(-50%, -50%);
                            -ms-transform: translate(-50%, -50%);
                            -o-transform: translate(-50%, -50%);
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }

            #communities {
                margin: 75px auto 75px auto;
                max-width: 595px;
                width: 100%;
                position: relative;
                text-align: center;
                padding: 0;
                p.ech-title {
                    font-family: "LibreBaskerville Bold", sans-serif;
                    font-size: 32px;
                    text-align: center;
                    padding-bottom: 50px;
                }
                .community {
                    position: relative;
                    max-width: 255px;
                    width: 255px;
                    height: 300px;
                    display: inline-block;
                    text-align: center;
                    div {
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        text-align: center;
                        p:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            padding-bottom: 10px;
                        }
                        p:not(:nth-of-type(1)) {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                        }
                    }
                    img {
                        max-width: 255px;
                        width: 255px;
                        max-height: 167px;
                        height: 167px;
                        object-fit: fill;
                    }
                }
                .community:nth-of-type(1) {
                    margin: 0 35px 25px 0;

                }
                .community:nth-of-type(2) {
                    margin: 0 0 25px 35px;
                }

                .community:nth-of-type(3) {
                    margin-right: 35px;
                }

                .community:nth-of-type(4) {
                    margin-left: 35px;
                }
            }

            #testimonials {
                padding: 0 20px;
                margin-bottom: 100px;
                .testimonial {
                    margin: 10px 0;
                    width: 30%;
                    display: inline-block;
                    vertical-align: top;
                    padding: 0 5px;
                    .testimonial_quote {
                        margin-bottom: 25px;
                    }
                    p:nth-of-type(2) {
                        font-weight: bolder;
                    }
                }
            }

            #footer-top {
                position: relative;
                height: 450px;
                margin: 50px auto 0 auto;
                max-width: 768px;
                width: 100%;
                padding: 0;
                background-color: #C0C0C0;
                div:nth-of-type(1) {
                    position: absolute;
                    right: 1px;
                    top: 0;
                    padding: 0;
                    margin: 0;
                    max-width: 55%;
                    width: 100%;
                    img {
                        max-height: 450px;
                        height: 450px;
                        max-width: 100%;
                        width: auto;
                        object-fit: fill;
                        overflow: hidden;
                        padding: 0;
                        margin: 0;
                    }
                }

                div:nth-of-type(2) {
                    max-width: 45%;
                    width: 100%;
                    max-height: 450px;
                    height: 450px;
                    background-color: #C0C0C0;
                    text-align: center;
                    position: absolute;
                    padding: 0;
                    margin: 0;
                    div {
                        position: relative;
                        width: 100%;
                        max-width: 100%;
                        max-height: 450px;
                        height: 450px;
                        p {
                            padding: 75px 25px 65px 25px;
                            color: #6B6969;
                            font-size: 20px;
                            font-weight: 400;
                            line-height: 1.2;
                            margin: 0 auto;
                        }
                        a {
                            font-size: 20px;
                            width: 45%;
                            border: 3px solid white;
                            background-color: #425152;
                            color: white;
                            padding: 7px 25px;
                            text-decoration: none;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }

    @media screen and (min-width: 769px) and (max-width: 1024px) {
        p.ech-title {
            font-family: "LibreBaskerville Bold", sans-serif;
            font-size: 32px;
            text-align: center;
            padding-bottom: 50px;
        }
        #home {
            max-width: 1024px;
            background-color: white;
            text-align: center;
            img {
                max-width: 100vw;
            }
            #home-head {
                position: relative;
                height: 500px;
                width: 100%;
                /*div.carousel {*/
                    /*max-height: 500px;*/
                    /*height: 500px;*/
                    /*color: white;*/
                    /*width: 100vw;*/
                    /*min-width: 100vw;*/
                img {
                    height: 425px;
                    max-height: 425px;
                    width: 100vw;
                    min-width: 100vw;
                    max-width: 100vw;
                }
                /*}*/

                .page-title {
                    font-family: "Tahu", "Muli", "Avenir", "Helvetica Neue", serif;
                    font-size: 4.5em;
                    position: absolute;
                    line-height: 1.1;
                    text-align: left;
                    top: 22%;
                    left: 15%;
                    color: white;
                }
                .start {
                    width: 165px;
                    font-size: 24px;
                    background-color: #425152;
                    color: white;
                    padding: 7px 0;
                    border: 2px solid white;
                    position: absolute;
                    top: 60%;
                    left: 15%;
                    outline: none;
                    font-weight: 500;
                    cursor: pointer;
                    z-index: 9;
                    text-decoration: none;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }

            #home-chips {
                clear: both;
                position: relative;
                height: 298px;
                max-height: 298px;
                margin: 50px auto 0 auto;
                max-width: 1024px;
                width: 100%;
                text-align: center;
                display: inline-block;
                div.ech-chip:nth-of-type(1) {
                    margin: 0 10px 0 0;
                }
                div.ech-chip:nth-of-type(2) {
                    margin: 0 10px;
                }
                div.ech-chip:nth-of-type(3) {
                    margin: 0 0 0 10px;
                }
                div.ech-chip {
                    width: 31%;
                    max-width: 31%;
                    display: inline-block;
                    height: 298px;
                    max-height: 298px;
                    position: relative;
                    cursor: pointer;
                    img {
                        max-width: 100%;
                        width: 100%;
                        max-height: 298px;
                        height: 298px;
                        object-fit: fill;
                    }
                    div.ech-chip-cutout {
                        background-color: white;
                        max-width: 175px;
                        width: 100%;
                        height: 100px;
                        max-height: 100px;
                        position: absolute;
                        bottom: 0;
                        p {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            font-size: 20px;
                            text-align: left;
                            -webkit-transform: translate(-50%, -50%);
                            -moz-transform: translate(-50%, -50%);
                            -ms-transform: translate(-50%, -50%);
                            -o-transform: translate(-50%, -50%);
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }

            #communities {
                margin: 75px auto 75px auto;
                max-width: 595px;
                width: 100%;
                position: relative;
                text-align: center;
                padding: 0;
                p.ech-title {
                    font-family: "LibreBaskerville Bold", sans-serif;
                    font-size: 32px;
                    text-align: center;
                    padding-bottom: 50px;
                }
                .community {
                    position: relative;
                    max-width: 255px;
                    width: 255px;
                    height: 300px;
                    display: inline-block;
                    text-align: center;
                    div {
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        text-align: center;
                        p:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            padding-bottom: 10px;
                        }
                        p:not(:nth-of-type(1)) {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                        }
                    }
                    img {
                        max-width: 255px;
                        width: 255px;
                        max-height: 167px;
                        height: 167px;
                        object-fit: fill;
                    }
                }
                .community:nth-of-type(1) {
                    margin: 0 35px 25px 0;

                }
                .community:nth-of-type(2) {
                    margin: 0 0 25px 35px;

                }

                .community:nth-of-type(3) {
                    margin-right: 35px;

                }

                .community:nth-of-type(4) {
                    margin-left: 35px;

                }
            }

            #testimonials {
                padding: 0 20px;
                margin-bottom: 100px;
                .testimonial {
                    margin: 10px 0;
                    width: 30%;
                    display: inline-block;
                    vertical-align: top;
                    padding: 0 5px;
                    .testimonial_quote {
                        margin-bottom: 25px;
                    }
                    p:nth-of-type(2) {
                        font-weight: bolder;
                    }
                }
            }

            #footer-top {
                position: relative;
                height: 500px;
                margin: 50px auto 0 auto;
                max-width: 1024px;
                width: 100%;
                padding: 0;
                background-color: #C0C0C0;
                div:nth-of-type(1) {
                    position: absolute;
                    right: 1px;
                    top: 0;
                    padding: 0;
                    margin: 0;
                    max-width: 55%;
                    width: 100%;
                    img {
                        max-height: 500px;
                        height: 500px;
                        max-width: 100%;
                        width: auto;
                        object-fit: fill;
                        overflow: hidden;

                        padding: 0;
                        margin: 0;
                    }
                }

                div:nth-of-type(2) {
                    max-width: 45%;
                    width: 100%;
                    max-height: 500px;
                    height: 500px;
                    background-color: #C0C0C0;
                    text-align: center;
                    position: absolute;
                    padding: 0;
                    margin: 0;
                    div {
                        position: relative;
                        width: 100%;
                        max-width: 100%;
                        max-height: 500px;
                        height: 500px;
                        p {
                            padding: 75px 25px 65px 25px;
                            color: #6B6969;
                            font-size: 24px;
                            font-weight: 400;
                            line-height: 1.2;
                            margin: 0 auto;
                        }
                        a {
                            font-size: 24px;
                            width: 45%;
                            border: 3px solid white;
                            background-color: #425152;
                            color: white;
                            padding: 7px 25px;
                            text-decoration: none;
                            text-align: center;
                        }
                    }

                }
            }
        }
    }

    @media screen and (min-width: 1025px) {
        p.ech-title {
            font-family: "LibreBaskerville Bold", sans-serif;
            font-size: 2em;
            text-align: center;
            padding-bottom: 50px;
        }
        .VueCarousel-pagination {
            position: relative;
            margin-top: -50px;
            z-index: 999;
        }
        #home {
            background-color: white;
            position: relative;
            text-align: center;
            #home-head {
                position: relative;
                height: 527px;
                .VueCarousel {
                    max-height: 527px;
                    height: 527px;
                    color: white;
                    width: 100%;
                    min-width: 100%;
                    display: inline-block;
                    /*img.jumbotron__image {*/

                    /*}*/
                    img {
                        height: 527px;
                        max-height: 527px;
                        width: 100%;
                        max-width: 100%;
                        -webkit-transform: scale(1, 1.6);
                        -moz-transform: scale(1, 1.6);
                        -ms-transform: scale(1, 1.6);
                        -o-transform: scale(1, 1.6);
                        transform: scale(1, 1.6);
                    }
                }

                .page-title {
                    z-index: 999;
                    br {
                        display: none;
                    }
                    font-family: "Tahu", "Muli", "Avenir", "Helvetica Neue", serif;
                    font-size: 80px;
                    position: absolute;
                    top: 40%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -40%);
                    -moz-transform: translate(-50%, -40%);
                    -ms-transform: translate(-50%, -40%);
                    -o-transform: translate(-50%, -40%);
                    transform: translate(-50%, -40%);
                    text-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                    color: #eee;
                }



                .start {
                    width: 165px;
                    font-size: 24px;
                    background-color: #425152;
                    color: white;
                    padding: 7px 0;
                    border: 2px solid white;
                    position: absolute;
                    top: 60%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -moz-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    -o-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    outline: none;
                    font-weight: 500;
                    cursor: pointer;
                    z-index: 9;
                    text-decoration: none;
                    text-align: center;
                    -webkit-transition-duration: 150ms; /* Safari */
                    transition-duration: 150ms;
                    &:hover {
                        box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);
                    }
                }
            }

            #home-chips {
                clear: both;
                margin: 60px auto 0 auto;
                height: 327px;
                max-height: 327px;
                max-width: 1200px;
                width: 100%;
                text-align: center;
                /*display: inline-block;*/
                div.ech-chip {
                    width: 100%;
                    max-width: 350px;
                    display: inline-block;
                    height: 327px;
                    max-height: 327px;
                    margin: 0 15px;
                    position: relative;
                    cursor: pointer;
                    img {
                        max-width: 100%;
                        width: 100%;
                        max-height: 327px;
                        height: 327px;
                        object-fit: fill;
                    }
                    div.ech-chip-cutout {
                        background-color: white;
                        max-width: 163px;
                        width: 100%;
                        height: 100px;
                        max-height: 100px;
                        position: absolute;
                        bottom: 0;
                        p {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            font-size: 20px;
                            text-align: left;
                            -webkit-transform: translate(-50%, -50%);
                            -moz-transform: translate(-50%, -50%);
                            -ms-transform: translate(-50%, -50%);
                            -o-transform: translate(-50%, -50%);
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }

            #communities {
                clear: both;
                margin: 100px auto 0 auto;
                max-width: 1200px;
                width: 100%;
                position: relative;
                text-align: center;
                /*display: inline-block;*/
                p.ech-title {
                    font-family: "LibreBaskerville Bold", sans-serif;
                    font-size: 2em;
                    text-align: center;
                    padding-bottom: 50px;
                }
                .community {
                    position: relative;
                    max-width: 255px;
                    width: 100%;
                    max-height: 167px;
                    height: 167px;
                    display: inline-block;
                    margin: 0 15px;
                    img {
                        max-width: 255px;
                        width: 100%;
                        max-height: 167px;
                        height: 100%;
                        object-fit: fill;
                        cursor: pointer;
                    }
                    div {
                        margin-top: 10px;
                        p:nth-of-type(1) {
                            font-size: 22px;
                            padding-bottom: 10px;
                            font-weight: 600;
                        }
                        p:not(:nth-of-type(1)) {
                            font-weight: 400;
                            font-size: 16px;
                            padding: 0;
                            margin: 0;
                        }
                    }
                }

            }

            #testimonials {
                clear: both;
                margin: 100px auto 0 auto;
                padding: 0 20px;
                max-width: 1200px;
                width: 100%;
                position: relative;
                text-align: center;
                .testimonial {
                    display: inline-block;
                    width: 27%;
                    top: 0;
                    margin: 0 20px;
                    text-align: center;
                    vertical-align: top;
                    .testimonial_quote {
                        padding: 0 5px 20px 5px;
                        margin: 0;
                        /*top: 0;*/
                        /*position: relative;*/
                        /*<!-- -webkit-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);-->*/
                        /*<!-- -moz-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);-->*/
                        /*<!--box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);-->*/
                    }
                    p:nth-of-type(1) {
                        font-size: 18px;
                    }
                    p:nth-of-type(2) {
                        font-size: 18px;
                        font-weight: bolder;
                        vertical-align: bottom;
                    }
                }

                /*div.carousel {*/
                    /*max-width: 1200px;*/
                    /*width: 100%;*/
                    /*height: 150px;*/
                    /*max-height: 150px;*/
                    /*box-shadow: none;*/
                    /*font-size: 24px;*/
                    /*font-style: italic;*/
                    /*font-weight: 300;*/
                    /*div.jumbotron {*/
                        /*max-width: 700px;*/
                        /*width: 100%;*/
                        /*margin: 0 auto;*/
                    /*}*/
                /*}*/
            }

            #footer-top {
                position: relative;
                height: 540px;
                max-width: 1100px;
                width: 100%;
                margin: 100px auto 100px auto;
                padding: 0;
                background-color: #C0C0C0;
                div:nth-of-type(1) {
                    position: absolute;
                    right: 0;
                    top: 0;
                    padding: 0;
                    margin: 0;
                    max-width: 605px;
                    width: 100%;
                    max-height: 540px;
                    height: 540px;
                    img {
                        max-height: 540px;
                        height: 540px;
                        max-width: 605px;
                        width: 100%;
                        object-fit: fill;
                        overflow: hidden;
                        padding: 0;
                        margin: 0;
                        position: absolute;
                        top: 50%;
                        right: 0;
                        transform: translateY(-50%);
                        cursor: pointer;
                    }
                }

                div:nth-of-type(2) {
                    position: absolute;
                    top: 0;
                    left: 0;
                    max-width: 495px;
                    width: 100%;
                    max-height: 540px;
                    height: 540px;
                    padding: 0;
                    margin: 0;
                    text-align: center;
                    div {
                        position: relative;
                        width: 100%;
                        max-width: 495px;
                        max-height: 540px;
                        height: 540px;
                        margin: 0 auto;
                        text-align: center;
                        p {
                            padding: 110px 0 50px 0;
                            color: #6B6969;
                            font-size: 22px;
                            font-weight: 400;
                            line-height: 1.2;
                            text-align: center;
                            width: 75%;
                            margin: 0 auto;
                        }
                        a {
                            font-size: 20px;
                            width: 45%;
                            border: 3px solid white;
                            background-color: #425152;
                            color: white;
                            padding: 7px 25px;
                            text-decoration: none;
                            text-align: center;
                            /*margin-left: 100px;*/
                        }
                    }
                }
            }
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue